import i18next from "../i18n";
import View from "./View";

class SignUpView extends View {
  _btnShowPassword = document.querySelector(".show-password");
  _emailField = document.querySelector("#email");
  _formSignIn = document.querySelector(".form-signin-account");
  _passwordField = document.querySelector("#password");
  _passwordSyncInterval = null;
  _signInBtn = document.querySelector("#sign-in");

  _setPasswordFieldType(field, targetType) {
    if (!field) {
      return;
    }

    const existingValue = field.value;
    const wasFocused = document.activeElement === field;

    field.setAttribute("type", targetType);
    field.type = targetType;

    // IOS AutoFill can keep secure masking until value is re-applied.
    if (existingValue) {
      field.value = "";
      field.value = existingValue;
    }

    if (wasFocused) {
      field.focus({ preventScroll: true });
    }
  }

  _syncPasswordUI() {
    const hasValue = this._passwordField.value !== "";
    this._btnShowPassword.style.display = hasValue ? "block" : "none";

    if (!hasValue) {
      this._setPasswordFieldType(this._passwordField, "password");
      this._btnShowPassword.textContent = i18next.t("password.show");
    }

    this.toggleSubmitButton();
  }

  // Initialize event listeners to control the submit button state
  initSubmitBtn() {
    [this._passwordField, this._emailField].forEach((el) =>
      el.addEventListener("input", this.toggleSubmitButton.bind(this)),
    );
  }

  renderValidation() {
    this._signInBtn.onclick = () => {
      const isValid =
        this._passwordField.value !== "" &&
        this.testEmail(this._emailField.value);

      // if (isValid) {
      //   this._formSignIn.reset();
      // }
    };
  }

  // Toggle password after show button click
  togglePassword() {
    this._btnShowPassword.onclick = () => {
      const shouldReveal = this._passwordField.type === "password";
      this._setPasswordFieldType(
        this._passwordField,
        shouldReveal ? "text" : "password",
      );
      this._btnShowPassword.textContent = i18next.t(
        shouldReveal ? "password.hide" : "password.show",
      );
    };
  }

  togglePasswordBtn() {
    const AUTOFILL_SYNC_INTERVAL_MS = 400;
    const sync = this._syncPasswordUI.bind(this);
    ["input", "change", "blur", "focus"].forEach((eventName) =>
      this._passwordField.addEventListener(eventName, sync),
    );
    window.addEventListener("pageshow", sync);
    window.addEventListener("focus", sync);

    // Covers iOS AutoFill flows that do not dispatch input/change events.
    if (!this._passwordSyncInterval) {
      this._passwordSyncInterval = window.setInterval(
        sync,
        AUTOFILL_SYNC_INTERVAL_MS,
      );
    }

    sync();
  }

  // Toggle the state of the submit button based on input fields
  toggleSubmitButton() {
    const MIN_PASSWORD_LENGTH = 8;
    const MAX_EMAIL_LENGTH = 256;
    if (
      this._passwordField.value === "" ||
      this._passwordField.value.length < MIN_PASSWORD_LENGTH ||
      !this.testEmail(this._emailField.value) ||
      this._emailField.value.length > MAX_EMAIL_LENGTH
    ) {
      // Disable submit button
      this._signInBtn.disabled = true;
    } else {
      // Enable submit button
      this._signInBtn.disabled = false;
    }
  }
}

export default new SignUpView();
